export default "__VITE_ASSET__B3KxxzKn__"